import axios from '@/service/apiProvider.service'

/**
 * State.
 */
export const state: any = {
  cameras: [],
  businesses: [],
  branches: [],
  cities: [],
  areas: []
}

/**
 * Getters.
 */
export const getters: any = {
  all (state: any): any {
    return state
  },

  cameras (state: any): any {
    return state.cameras
  }
}

/**
 * Mutations.
 */
export const mutations: any = {
  PUSH_ALL (state: any, payload: any): void {
    for (const key in payload) {
      state[key] = payload[key]
    }
  }
}

/**
 * Actions.
 */
export const actions: any = {
  /**
   * Gathering.
   * 
   * @return {Promise}
   */
  async addOn ({ commit }: any, props: any) {
    let status: boolean = false

    try {
      const { data }: any = await axios(props.path)
      commit('PUSH_ALL', { [props.state]: data })
      status = true
    } catch (err) {
      console.warn('WARNING:', err.message)
    }

    return Promise.resolve(status)
  },

  /**
   * Cog data pull.
   * 
   * @return {Promise}
   */
  async pull ({ commit }: any) {
    let status: boolean = false
    let f: any = async (path: string) => {
      const { data }: any = await axios(path)
      return Promise.resolve(data)
    }

    try {
      const cameras: any = await f('/camera')
      commit('PUSH_ALL', { cameras })
      
      const businesses: any = await f('/business')
      const branches: any = await f('/branch')
      const cities: any = await f('/city')
      const areas: any = await f('/area')
      
      commit('PUSH_ALL', { businesses, branches, cities, areas })
      status = true
    } catch (err) {
      console.warn('WARNING:', err.message)
    }

    return Promise.resolve(status)
  },

  /**
   * 
   * @return {Promise}
   */
  async allFetch ({ dispatch }: any, h: any) {
    let status: any = false

    try {
      const { data }: any = await axios[h.method.toLocaleLowerCase()](h.path, h.body)
      if (data.status) {
        await dispatch('addOn', {
          path: h.get,
          state: h.mutation
        })
        status = data.status
      }
    } catch (err) {
      console.warn('WARNING:', err.message)
    }

    return Promise.resolve(status)
  }
}